import { RotationPortCallBM } from 'src/types/BusinessModel/Stowage/Rotation/RotationPortCallBM';
import { RotationPortCall } from 'src/types/ViewModel/Stowage/Rotation/RotationPortCall';
import { createRotationBerthCallList } from './RotationBerthCallFactory';
import { PortCallStatusEnum } from 'src/enums/stowage/portCallStatusEnum';

export const createRotationPortCall = (rotationPortCallBM: RotationPortCallBM): RotationPortCall => {
    const portCall: RotationPortCall = {
        imosPortCallId: rotationPortCallBM.portCallId,
        portId: rotationPortCallBM.portId,
        portCallGuid: crypto.randomUUID(),
        imoNumber: rotationPortCallBM.imoNumber,
        portOrderNumber: rotationPortCallBM.portOrderNumber,
        dataSource: rotationPortCallBM.dataSource,
        voyageNumber: rotationPortCallBM.voyageNumber,
        voyageStatus: rotationPortCallBM.voyageStatus,
        turnaroundVoyageNumber: rotationPortCallBM.turnaroundVoyageNumber,
        portDisplayName: rotationPortCallBM.portDisplayName,
        portCallStatus: getPortCallStatus(rotationPortCallBM.portStatus),
        departureDateTimeLocal: rotationPortCallBM.departureDate.plannedDateTimeLocal,
        departureDateTimeUtc: rotationPortCallBM.departureDate.plannedDateTimeUtc,
        arrivalDateTimeLocal: rotationPortCallBM.arrivalDate.plannedDateTimeLocal,
        arrivalDateTimeUtc: rotationPortCallBM.arrivalDate.plannedDateTimeUtc,
        hasArrived: rotationPortCallBM.hasArrived,
        hasDeparted: rotationPortCallBM.hasDeparted,
        hasCorrectStatus: rotationPortCallBM.hasCorrectStatus,
        imosPortFunction: rotationPortCallBM.imosPortFunction,
        berthCalls: null,
    };
    portCall.berthCalls = createRotationBerthCallList(rotationPortCallBM.berthCalls, portCall);
    return portCall;
};

export const getPortCallStatusDescription = (portCallStatus: PortCallStatusEnum): string => {
    switch (portCallStatus) {
        case PortCallStatusEnum.Departed:
            return 'Departed';
        case PortCallStatusEnum.Arrived:
            return 'Arrived';
        case PortCallStatusEnum.Planned:
            return 'Planned';
        default:
            return '';
    }
};

const getPortCallStatus = (portStatus: string): PortCallStatusEnum => {
    switch (portStatus) {
        case 'SA':
        case 'TE':
            return PortCallStatusEnum.Departed;
        case 'AR':
            return PortCallStatusEnum.Arrived;
        default:
        case '..':
            return PortCallStatusEnum.Planned;
    }
};

export const createRotationPortCallList = (rotationPortCallList: RotationPortCallBM[]) =>
    rotationPortCallList.map((rotationPortCall) => createRotationPortCall(rotationPortCall));
